// extracted by mini-css-extract-plugin
export default {"logo":"Main_logo__VNxJd","text":"Main_text__hz+so","wrapSearch":"Main_wrapSearch__XvvnE","search":"Main_search__ewHbD","list":"Main_list__d+cbi"};